import React, { createContext } from 'react'
import { MenuOutlined } from '@ant-design/icons'
import './sortable-list.scss'
import { Draggable } from 'react-beautiful-dnd'

const DragHandleContext = createContext()

export function SortableItem({ children, id, index }) {
    return (
        <Draggable draggableId={id} index={index}>
            {provided => (
                <li className='SortableItem' ref={provided.innerRef} {...provided.draggableProps}>
                    <DragHandleContext.Provider value={provided.dragHandleProps}>{children}</DragHandleContext.Provider>
                </li>
            )}
        </Draggable>
    )
}

export function DragHandle({ tooltipText = 'Move item' }) {
    const dragHandleProps = React.useContext(DragHandleContext)

    return (
        <div className='DragHandle d-flex-center m-8' title={tooltipText} {...dragHandleProps}>
            <MenuOutlined />
        </div>
    )
}
